import KeywordFilter from "components/filters/Filters/KeywordFilter";
import ListTemplate from "components/ListTemplate";
import TwoColumnLayout from "layout/TwoColumnLayout";
import React from "react";
import { routes } from "utilities/routing/generatedRoutes";
import { mapFilterValuesToInstruction, mapResponseToFilterValues } from "./helpers";
import RightSideNavigation from "components/RightSideNavigation/RightSideNavigation";
import LimitedList from "components/LimitedList";
import { useLoaderData } from "react-router";
import { FreeFieldPermissionProfileSidePanel } from "components/SidePanel/FreeFieldPermissionProfile/FreeFieldPermissionProfileSidePanel";

const FreefieldProfileList = () => {
  const viewModel = useLoaderData<server.viewmodel.FreeFieldProfileListFrontModel>();

  const getPermissionCount = (item: server.dto.FreeFieldProfileForList, level: server.dto.FreeFieldPermissionLevels) => {
    const foundPermission = item.freeFieldProfilePermissions.find(p => p.freeFieldPermissionLevel === level);

    return foundPermission?.count ?? 0;
  }

  return <TwoColumnLayout>
    <TwoColumnLayout.LeftColumn>
      <ListTemplate
        title={viewModel.pageTitle}
        filterSet={viewModel.environment === "internal" ? "freeFieldProfile_Internal_List" : "freeFieldProfile_External_List"}
        defaultFilters={viewModel.defaultFilters}
        initialInstruction={{ ...viewModel.initialInstruction, environment: viewModel.environment }}
        fetchFunction={window.CoreApi.FreeFieldProfile.Paginated}
        getId={item => item.freeFieldProfileId}
        onNew={() => window.location.href = routes.freeFieldProfile_New(viewModel.environment).absolute}
        layout={{
          type: "table",
          hideHeader: true,

          columns: [
            {
              key: "title",
              header: "",
              size: "1fr",
              render: (item) => <FreeFieldPermissionProfileSidePanel
                freeFieldPermissionProfileId={item.freeFieldProfileId}
                environment={viewModel.environment}
                trigger={<a>{item.title}</a>}
              />,
            }, {
              key: "assignedUsers",
              header: "",
              size: "1fr",
              render: (item) => <LimitedList
                items={item.assignedUsers}
                renderItem={user => <div key={user}>{user}</div>}
                renderExcess={nr => <a href={`${routes.freeFieldProfile_Detail(viewModel.environment, item.freeFieldProfileId).absolute}#users`}>+{nr} {RESX.Planning.More}</a>}
                limit={5}
                delimiter=""
              />
            },
            {
              key: "circlesWithLabels",
              header: "",
              size: "minmax(auto, 120px)",
              render: () => <>
                <div>
                  <i className="icon-circle red margin-right-small"></i>
                  {RESX.Webform.Hidden}:
                </div>
                {viewModel.environment === "internal" && <>
                  <div>
                    <i className="icon-circle orange margin-right-small"></i>
                    {RESX.GeneralLabels.Visible}:
                  </div>
                  <div>
                    <i className="icon-circle green margin-right-small"></i>
                    {RESX.SoUser.Modify}:
                  </div>
                </>}
                {viewModel.environment === "external" && <div>
                  <i className="icon-circle green margin-right-small"></i>
                  {RESX.SoUser.Access}:
                </div>}
              </>
            }, {
              key: "permissionCounts",
              header: "",
              size: "auto",
              render: (item) => <>
                <div>
                  {getPermissionCount(item, "hidden")}
                </div>
                {viewModel.environment === "internal" && <div>
                  {getPermissionCount(item, "view")}
                </div>}
                <div>
                  {getPermissionCount(item, "viewModify")}
                </div>
              </>
            }
          ]
        }}
        filters={<>
          <KeywordFilter placeholder={RESX.GeneralLabels.Search} />
        </>}
        functions={{
          mapResponseToFilterValues,
          mapFilterValuesToInstruction: mapFilterValuesToInstruction(viewModel.environment)
        }}
      />
    </TwoColumnLayout.LeftColumn>
    <RightSideNavigation
      title={desktopNavigation.rightSideNavigation.title}
      menuItems={desktopNavigation.rightSideNavigation.items}
      currentPage={desktopNavigation.currentPage}
    />
  </TwoColumnLayout>
};


export default FreefieldProfileList;